import React from 'react';
import { ICheckboxGroupField } from './interfaces';
import { FormControl, FormGroup, FormLabel } from '@mui/material';
import { CheckboxOption } from '../CheckboxOption';

export const CheckboxGroupField: React.FC<ICheckboxGroupField> = ({
  label,
  required,
  error,
  value,
  options,
  onChange,
}): JSX.Element => {
  const handleChange = (fieldValue: string | number, checked: boolean) => {
    let newValues = value ? [...value] : [];

    if (checked) {
      newValues.push(fieldValue);
    } else {
      newValues = newValues.filter((val) => val !== fieldValue);
    }

    onChange(newValues);
  };

  const isChecked = (optionValue: string | number) => {
    return (value || []).indexOf(optionValue) !== -1;
  };

  return (
    <FormControl>
      <FormLabel
        error={error}
        required={required}
        sx={{
          fontSize: '12px',
          textTransform: 'uppercase',
          fontWeight: 'bold',
        }}
      >
        {label}
      </FormLabel>
      <FormGroup>
        {options.map((optionProps) => {
          return (
            <CheckboxOption
              key={optionProps.value}
              value={optionProps.value}
              label={optionProps.label}
              checked={isChecked(optionProps.value)}
              onChange={(checked) => handleChange(optionProps.value, checked)}
            />
          );
        })}
      </FormGroup>
    </FormControl>
  );
};
